<template>
  <span class="amount">{{ $Util.formatNumber(current) }}</span>
</template>
<script>
export default {
  props: {
    before: 0,
    after: 0,
  },
  data: function () {
    return {
      current: this.before,
      timeout: 10,
      basic: -11111,
      type: 1
    }
  },
  watch: {
    before: function (val) {
      this.current = val
    },
    after: function (val) {
      this.timeout = Math.round(500 / ((this.before - this.after) / 11111))
    }
  },
  created: function () {
    if (this.before > this.after) {
      this.type = 1
      this.basic = -11111
      this.timeout = Math.round(500 / ((this.before - this.after) / 11111))
    } else {
      this.type = 2
      this.basic = 11111
      this.timeout = Math.round(500 / ((this.after - this.before) / 11111))
    }
  },
  methods: {
    restart: function () {
      this.before = 0
      this.current = 0
      this.start()
    },
    start: function () {
      if (this.type === 1) {
        if (this.current >= this.after) {
          setTimeout(() => {
            this.current = this.current + this.basic
            this.start()
          }, this.timeout)
        } else {
          this.current = this.after
        }
      } else {
        if (this.current <= this.after) {
          setTimeout(() => {
            this.current = this.current + this.basic
            this.start()
          }, this.timeout)
        } else {
          this.current = this.after
        }
      }
    }
  }
}
</script>
